<template>
    <v-card class="elevation-1 rounded-4"> 
        <v-toolbar flat height="45px">
            <span class="font-weight-bold">Confirm</span>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text class="text-xs-center">
            <p v-html="deleteMessage" class="msg-text"></p>
            <p v-html="note"></p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn title="Delete" class="red" dark @click="okDelete" :loading="loading">{{ okLabelText }}</v-btn>
            <v-btn title="Cancel" @click="closeDialog">Cancel</v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>

export default {
    data () {
        return {
            loading: false,
            deleteMessage: null,
            note: "Note: you will not be able to undo this operation."
        }
    },
    props: ['okLabel'],
    methods: {
        setMessage(message) {
            this.deleteMessage = message
        },
        setNote(note) {
            this.note = note
        },
        okDelete() {
            this.loading = true
            this.$emit('okDelete', null)
            this.loading = false
        },
        closeDialog() {
            this.$emit('update:dialogDelete', false)
        },
    },
    computed: {
        okLabelText() {
            return this.okLabel ? this.okLabel : 'Delete'
        }
    }
}
</script>
<style scoped>
.msg-text {
    margin-top:10px;
}
</style>